<nav class="inline-flex items-center">
  <p class="empty:hidden mr-8 text-sm font-medium text-on-surface dark:text-on-surface-darkmode">
    <ng-content select="[slot=title]" />
  </p>
  <ol role="list" class="flex items-center gap-5">
    <ng-content select="ui-stepper-step" />
  </ol>
</nav>
